// Importaciones de React, estilos, la imagen del certificado y el componente de Alerta de Material-UI.
import React, { useState, useEffect } from 'react';
import './Certificado.css'; // Estilos específicos para este componente.
import imagen from '../certificados/f4hpb0omog5ce.png'; // La imagen específica de este certificado.
import Alert from '@mui/material/Alert'; // Componente de alerta para mostrar notificaciones.

/**
 * Componente Certificado (en este caso, Certificado 1).
 * Muestra una página dedicada a un único certificado.
 * Incluye una funcionalidad para expandir la imagen en dispositivos móviles
 * y una alerta temporal que instruye al usuario sobre cómo hacerlo.
 */
export const Certificado = () => {
  // Estado para controlar si la vista del certificado está expandida (modo "zoom").
  const [isExpanded, setIsExpanded] = useState(false);
  // Estado para controlar la visibilidad de la alerta informativa.
  const [showAlert, setShowAlert] = useState(true);

  // Efecto que se ejecuta una vez al montar el componente para ocultar la alerta después de 4 segundos.
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAlert(false);
    }, 4000);

    // Función de limpieza: se ejecuta al desmontar el componente para limpiar el temporizador.
    return () => clearTimeout(timer);
  }, []); // El array vacío `[]` asegura que el efecto se ejecute solo una vez.

  /**
   * Manejador para el evento de clic/toque en el contenedor.
   * Alterna el estado `isExpanded` para hacer "zoom" en la imagen,
   * pero solo funciona en pantallas con un ancho de 768px o menos (móviles/tablets).
   */
  const handleToggle = () => {
    if (window.innerWidth <= 768) {
      setIsExpanded(!isExpanded);
      // Opcionalmente, podría ocultar la alerta al interactuar.
      if (isExpanded) {
        setShowAlert(false);
      }
    }
  };

  return (
    // Contenedor principal. La clase `expanded` se aplica condicionalmente para el efecto de zoom.
    <div 
      className={`certificado-container ${isExpanded ? 'expanded' : ''} bg-[#0e0f52] text-white`} 
      onClick={handleToggle}
    >
      <h2 className="certificado-titulo">Certificado</h2>
      <img className="certificado-imagen" src={imagen} alt="Certificado" />
      
      {/* El botón de cierre solo se muestra cuando la imagen está expandida. */}
      {isExpanded && (
        <button className="close-button" onClick={handleToggle}>
          X
        </button>
      )}
      
      {/* La alerta solo se muestra si `showAlert` es verdadero. */}
      {showAlert && (
        <Alert severity="info">¡Aviso! Si estás en celular, haz clic en el certificado para verlo más grande.</Alert>
      )}
    </div>
  );
};

// Exporta el componente.
export default Certificado;